import Error from "./section-components/error";

const ErrorPage = () => {
  return <Error />;
};

export default ErrorPage;
